import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
    widgetContainer: {
        paddingBottom: '16px',
        position: 'relative',
    },
    // Offset so smooth-scroll targets clear the fixed header + sticky tabs.
    sectionAnchor: {
        scrollMarginTop: 120,
    },
    // Roomier section padding to match the design (vs the Widget default 24px).
    sectionBody: {
        padding: '36px 28px !important',
    },
});

export default styles;
export const useStyles = makeStyles(styles);
